module.exports = __webpack_public_path__ + "static/media/5.09b0e7f4.jpg";